import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/insert-management/edit/step4/index.html';

const links: Record<string, string> = {
  insert: '/infoTrac/insert-management',
  submit: '/infoTrac/insert-management?act=saved',
  prevStep: '/infoTrac/insert-management/step3',
  nextStep: '/infoTrac/insert-management/step5',
};

function InsertManagementEditStep4() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const insert = iframeDocument.getElementsByClassName('insert-management');
      const submit = iframeDocument.getElementsByClassName('saveBtn');
      const nextStep = iframeDocument.getElementsByClassName('next-step');
      const prevStep = iframeDocument.getElementsByClassName('prev-step');

      if (insert.length) {
        for (let i = 0; i < insert.length; i++) {
          insert[i].addEventListener('click', () => navigate(links.insert));
        }
      }

      if (submit.length) {
        for (let i = 0; i < submit.length; i++) {
          submit[i].addEventListener('click', () => navigate(links.submit));
        }
      }

      if (nextStep.length) {
        for (let i = 0; i < nextStep.length; i++) {
          nextStep[i].addEventListener('click', () => navigate(links.nextStep));
        }
      }

      if (prevStep.length) {
        for (let i = 0; i < prevStep.length; i++) {
          prevStep[i].addEventListener('click', () => navigate(links.prevStep));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="insert-management-edit-step-4" src={path} width="100%" height="1000px" />;
}

export default InsertManagementEditStep4;
